import React from "react";
import { Plus } from "lucide-react";

// O que o sistema aprendeu dos pedidos da loja: é daqui que saem as sugestões.
export default function Combinacoes({ combinacoes, pedidos }) {
  return (
    <section className="rounded-xl border bg-card p-4 sm:p-5" data-e2e="combinacoes-loja">
      <h3 className="font-semibold">O que seus clientes pedem junto</h3>
      <p className="text-xs text-muted-foreground mb-3">
        Aprendido de {pedidos} pedidos dos últimos 90 dias. As sugestões partem destas combinações e se atualizam sozinhas.
      </p>
      {(combinacoes || []).length === 0 ? (
        <p className="text-sm text-muted-foreground py-4 text-center">Ainda poucos pedidos com mais de um produto — as sugestões usam complementos e os mais vendidos.</p>
      ) : (
        <ul className="space-y-2">
          {combinacoes.map((c) => (
            <li key={`${c.a}-${c.b}`} className="flex items-center gap-2 text-sm">
              <span className="truncate font-medium max-w-[40%]">{c.a}</span>
              <Plus className="w-3.5 h-3.5 text-sky-500 shrink-0" />
              <span className="truncate font-medium flex-1 min-w-0">{c.b}</span>
              <span className="text-xs text-muted-foreground tabular-nums shrink-0">{c.juntos} pedidos</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
